import type { AnswerInputProps } from '../QuestionRenderer'

export function DividerBlock({ question }: AnswerInputProps<null>) {
  const label = question.settings.dividerLabel

  return (
    <div
      className="flex items-center gap-4 py-6"
      style={{ color: 'var(--form-answer,#64748B)' }}
    >
      <div
        className="h-px flex-1"
        style={{
          borderTop: `1px ${question.settings.dividerStyle ?? 'solid'} color-mix(in srgb, var(--form-accent,#6366F1) 42%, transparent)`,
        }}
      />
      {label && (
        <div
          className="rounded-full border px-3 py-1 text-sm font-medium"
          style={{
            borderColor: 'color-mix(in srgb, var(--form-accent,#6366F1) 24%, transparent)',
            color: 'var(--form-answer,#64748B)',
            fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
          }}
        >
          {label}
        </div>
      )}
      <div
        className="h-px flex-1"
        style={{
          borderTop: `1px ${question.settings.dividerStyle ?? 'solid'} color-mix(in srgb, var(--form-accent,#6366F1) 42%, transparent)`,
        }}
      />
    </div>
  )
}
